import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { VpModal, VpModalBody, VpModalCloseButton, VpModalDialog, VpModalFooter, VpModalHeader } from '@vtmn-play/react'

interface ModalProps {
  open: boolean
  title: string
  children: ReactNode
  footer: ReactNode
  onClose?: () => void
  closeOnClickOutside?: boolean
  showCloseButton?: boolean
  closeDisabled?: boolean
}

const Modal = ({
  open,
  title,
  children,
  footer,
  onClose,
  closeOnClickOutside = false,
  showCloseButton = false,
  closeDisabled = false
}: ModalProps) => {
  const { t } = useTranslation()
  const close = () => {
    if (closeDisabled || !onClose) return
    onClose()
  }

  return (
    <VpModal open={open} onClose={close} closeOnClickOutside={closeOnClickOutside && !closeDisabled}>
      <VpModalDialog>
        <VpModalHeader>
          <div className="vp-title-m">{title}</div>
          {showCloseButton && !closeDisabled && <VpModalCloseButton aria-label={t('close')} />}
        </VpModalHeader>
        <VpModalBody>
          <div className="mg-modal-body">{children}</div>
        </VpModalBody>
        <VpModalFooter>
          <div className="mg-modal-footer">{footer}</div>
        </VpModalFooter>
      </VpModalDialog>
    </VpModal>
  )
}

export default Modal
